module.exports = __webpack_public_path__ + "static/media/vulve-rose.ed60b62e.png";